import { render, staticRenderFns } from "./VVideoUpload.vue?vue&type=template&id=628b5c7b&scoped=true"
import script from "./VVideoUpload.vue?vue&type=script&lang=ts"
export * from "./VVideoUpload.vue?vue&type=script&lang=ts"
import style0 from "./VVideoUpload.vue?vue&type=style&index=0&id=628b5c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b5c7b",
  null
  
)

export default component.exports